import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const systemPreferenceUpdateService = (data: any) => {
  return axiosInstance
    .put(ENDPOINTS.ADMIN.SYSTEM.PREFERENCE.UPDATE, data)
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
